<div class="page">
  <div class="card">
    <div class="card-header">
      <h1>{{ 'horairesInformations.informations.title' | translate }}</h1>
      <p class="subtitle">{{ 'horairesInformations.informations.subtitle' | translate }}</p>
    </div>

    <div class="content">
      <p>{{ 'horairesInformations.informations.underConstruction' | translate }}</p>
    </div>
  </div>
</div>
